document.addEventListener('DOMContentLoaded', function() {
    if (document.referrer.includes('abonnement-culottes-d-apprentissage-ecologiques-bebe') || document.referrer.includes('abonnement-couches-ecologiques-bebe') || document.referrer.includes('abonnement-couches-et-culottes-ecologiques-bebe') || document.referrer.includes('subscriptions-ecological-nappies-and-diapers-for-babies') || document.referrer.includes('subscriptions-ecological-nappies-for-baby') || document.referrer.includes('nappy-pants-subscription')) {
        var subscriptionWidget = document.querySelector('.product-subscription-widget-radios');
        if (subscriptionWidget) {
            var firstRadioItem = subscriptionWidget.querySelector('.product-subscription-widget-radios-item:first-child .product-subscription-widget-radio');
            if (firstRadioItem) {
                setTimeout(() => {
                    firstRadioItem.click();
                }, 1000);

            }

            var secondRadioItem = subscriptionWidget.querySelector('.product-subscription-widget-radios-item:nth-child(2)');
            if (secondRadioItem) {
                secondRadioItem.style.display = 'none';
            }
        }
    }
});